import React from 'react'
import PropTypes from 'prop-types'
import { merge, isNumber } from 'lodash'
import Text from '../Text/Text'
import styles from './avatar.module.scss'

const getInitials = (name, size = 1) => {
  if (!name) return ''

  return name
    .split(' ')
    .map((item) => item.charAt(0).toUpperCase())
    .join('')
    .substring(0, size)
}

function Avatar(props) {
  const { title, image, size, color, radius } = props

  let theme

  switch (color) {
    case 'white':
      theme = {
        color: 'gray',
        variation: 'dark',
        background: '#FFF'
      }
      break

    case 'base': {
      theme = {
        color: 'white',
        background: '#737373'
      }
      break
    }

    default:
      theme = {
        color: 'white',
        variation: 'dark',
        background: '#4D4D4D'
      }
      break
  }

  let sizeAvatar

  switch (size) {
    case 'extra-small':
      sizeAvatar = {
        width: '24px',
        height: '24px',
        size: 'xxs',
        letter: 2
      }
      break

    case 'small':
      sizeAvatar = {
        width: '32px',
        height: '32px',
        size: 'md',
        letter: 2
      }
      break

    case 'medium':
      sizeAvatar = {
        width: '48px',
        height: '48px',
        size: 'mlg',
        letter: 2
      }
      break

    default:
      sizeAvatar = {
        width: '64px',
        height: '64px',
        size: 'mlg',
        letter: 2
      }
      break
  }
  const imageStyles = {}
  if (radius && isNumber(radius)) imageStyles.borderRadius = `${radius}px`

  const initials = getInitials(title, sizeAvatar.letter)

  const avatarStyles = merge(
    {},
    !image && { background: theme.background },
    sizeAvatar,
    imageStyles
  )

  if (!image) {
    return (
      <div style={avatarStyles} className={styles.initials}>
        <Text
          className={styles.letter}
          size={sizeAvatar.size}
          color={theme.color}
          variation="dark"
          bold
        >
          {initials}
        </Text>
      </div>
    )
  }

  return (
    <img
      className={styles.gridItemImage}
      src={image}
      alt={title}
      style={avatarStyles}
    />
  )
}

Avatar.defaultProps = {
  title: null,
  image: null,
  size: null,
  color: null,
  radius: null
}

Avatar.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  radius: PropTypes.oneOfType([PropTypes.number])
}

export default Avatar
